<div class="Txt-Withdraw-Coinbase">
  <h2>Bitcoin</h2>
  <span>{{ 'desc_withdraw_coinbase' | t }}</span>

  <div style="margin-top: 20px">
    <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
  </div>

  <form class="example-form" [formGroup]="coinbaseWithdrawDatas">
    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'Amount' | t }} ($)" onKeyPress="if(this.value.length==10) return false;" type="number" formControlName="withdrawamount" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'Bitcoin_Address' | t }}" formControlName="bitcoinAddress" />
    </mat-form-field>
  </form>

  <button mat-raised-button class="form-submit-button" (click)="submitCoinbaseWithdrawData()" [disabled]="!coinbaseWithdrawDatas.valid">{{ 'submit' | t }}</button>
</div>
